import { Component, computed, inject, input } from '@angular/core';
import {
  CoreJssProxyModule,
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { JssPlatformService } from '@core/jss-platform';

import {
  AspectRatio,
  InformationCardComponent,
} from '../information-card/information-card.component';

export interface InformationCard {
  id: string;
  title: TextField;
  content: RichTextField;
  button: LinkField;
  image?: ImageField;
}

const MAX_CARDS = 4;

@Component({
  selector: 'wl-information-card-row',
  standalone: true,
  imports: [
    CommonUiUtilityComponentsModule,
    CoreJssProxyModule,
    InformationCardComponent,
  ],
  templateUrl: './information-card-row.component.html',
  styleUrls: [
    './information-card-row.component.ed.scss',
    './information-card-row.component.essent.scss',
  ],
})
export class InformationCardRowComponent {
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly title = input.required<TextField>();
  readonly content = input<TextField>();
  readonly cards = input.required<InformationCard[]>();

  readonly isContentEditorActive = this.#jssPlatformService.isEditorActive();

  readonly aspectRatio = computed<AspectRatio>(() => {
    const cardCount = this.cards().length;
    return cardCount === MAX_CARDS ? '1/1' : '4/3';
  });
}
